import React from "react";
import { HStack } from "@chakra-ui/react";
import { ToolsConfig } from "duck";
import {
  ColorPicker,
  Eraser,
  WidthSlider,
  Undo,
  Redo,
  Comments,
  Clear
} from "./components";

interface ToolsProps {
  toolsConfig: ToolsConfig;
  clearHandler: { clear(): void; isLoading: boolean };
}

const Tools: React.FC<ToolsProps> = ({ toolsConfig, clearHandler }) => {
  return (
    <HStack spacing={3}>
      <ColorPicker config={toolsConfig} />
      <Eraser config={toolsConfig} />
      <WidthSlider key={toolsConfig.penWidth} config={toolsConfig} />
      <Undo config={toolsConfig} />
      <Redo config={toolsConfig} />
      <Comments config={toolsConfig} />
      <Clear clearHandler={clearHandler} />
    </HStack>
  );
};

export default Tools;
